import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { SovelluksenVersio } from '../../_jaettu-lemonator/model/system'
import { FirebaseLemonator } from './firebase-lemonator.service'

@Injectable()
export class VersionTarkistusPalvelu {
  sovelluksenVersioObservable: Observable<SovelluksenVersio>

  constructor(private _firebase: FirebaseLemonator) {
    this.sovelluksenVersioObservable = this._firebase.firestoreDoc<SovelluksenVersio>('admin/sovelluksen-versio').listen()
  }

  public tarkistaVersio(versio: SovelluksenVersio | null) {
    if (environment.enableVersionCheck && versio) {
      if (versio.versio !== environment.version) {
        location.reload()
      }
    }
  }
}
